<template>
  <div>

    <DataTable ref="smsDataTable" :url="api.ACTIONS.SMS_CODES" :titles="titles"
      :fields-hidden-main="['id', 'updated_at']" :title="$t('priceRulesPage.smsCodes.pageTitle')" :enableEdit="false" :enableAdd="false"
      :enableDelete="false"  :formatter="formatter" />
  </div>
</template>

<style>
.hbtn {
  float: inline-end;
  z-index: 1;
  margin-top: 20px;
  margin-inline-end: 20px;
  padding: 0px 45px;
}
</style>

<script>
import DataTable from "@/components/monaco/DataTable";
import moment from "moment";

export default {
  name: "SMS Codes",
  title() {
    return this.$t("priceRulesPage.smsCodes.pageTitle");
  },
  components: { DataTable },
  data() {
    return {};
  },

  computed: {
    rules() {
      const required = (val) =>
        (val !== null && val !== undefined) ||
        this.$t("priceRulesPage.fieldRequired");
      return {
        name: [required],
      };
    },
    formatter() {
      return {
        created_at: (value) => this.$companyTime(value, 'DD-MM-YYYY - HH:mm')
      }
    },
    titles() {
      return {
        phone_number: this.$t("priceRulesPage.smsCodes.colPhone"),
        code: this.$t("priceRulesPage.smsCodes.colCode"),
        created_at: this.$t("priceRulesPage.smsCodes.colCreationTime"),
        end_time: this.$t("priceRulesPage.smsCodes.colEndTime"),
      };
    },
    actionsExtraMain() {
      return {
      };
    },
  },
};
</script>
